import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { TriageAction, TriageItem } from '../../shared/models';

/**
 * Used as downgraded in AJS.
 * Read only version of RandomDispatchActionComponent, without form, only displaying data
 */
@Component({
  selector: 'app-random-dispatch-action-read-only',
  templateUrl: './random-dispatch-action-read-only.component.html',
  styleUrls: ['./random-dispatch-action-read-only.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RandomDispatchActionReadOnlyComponent implements OnInit {
  @Input() action: TriageAction;
  @Input() items: TriageItem[];

  // group = item
  selectedGroup: TriageItem = null;

  constructor() {}

  ngOnInit(): void {
    // 4 loops is the best effort, the model should be redesigned, when migrating the parent page "triage" in angular.
    this.selectedGroup = this.items.find(group => group.id === this.action.parameters.tagGroupId);

    if (this.selectedGroup) {
      this.action.parameters.tagIdsAndPercentages.forEach(tagIdsAndPercentage => {
        this.selectedGroup.items.find(item => {
          return item.subitems.find(subitem => {
            if (subitem.id === tagIdsAndPercentage.tagId) {
              tagIdsAndPercentage.label = subitem.label;
              return true;
            }
            return false;
          });
        });
      });
    }
  }
}
